export default "__VITE_ASSET__3_9Z2kjT__"